import { api, sessionStatus } from "./lib/api";
import { byId, errorMessage } from "./lib/dom";

async function showDevSignIn(): Promise<void> {
  const { session, devLogin } = await sessionStatus();
  if (session?.role === "parent") {
    location.href = "/family/";
    return;
  }
  byId("dev").hidden = !devLogin;
}

byId<HTMLFormElement>("guide-form").addEventListener("submit", async (event) => {
  event.preventDefault();
  const error = byId("dev-error");
  error.hidden = true;
  try {
    await api.post("/dev/session", {
      role: "guide",
      name: byId<HTMLInputElement>("gname").value,
      email: byId<HTMLInputElement>("gemail").value,
    });
    location.href = "/guide/";
  } catch (err) {
    error.textContent = errorMessage(err);
    error.hidden = false;
  }
});

void showDevSignIn();
